export interface HandProps {
    x: number;
    y: number;
    w: number;
    h: number;
    rot: number;
    bob?: number;
    animate?: string;
    animName?: string;
}

interface HandBaseProps extends HandProps {
    side: 'left' | 'right';
}

const HandBase = ({ side, x, y, w, h, rot, bob = 0, animate, animName }: HandBaseProps) => (
    <div
        style={{
            position: 'absolute',
            ...(side === 'left' ? { left: x } : { right: x }),
            bottom: y + bob,
            width: w,
            height: h,
            borderRadius: '50%',
            background: 'linear-gradient(160deg, #a8affe 0%, #959bf8 100%)',
            filter: 'blur(0.5px)',
            zIndex: 3,
            transition: 'left 0.4s, right 0.4s, bottom 0.4s, width 0.3s, height 0.3s, transform 0.4s',
            transform: `rotate(${rot}deg)`,
            ...(animate
                ? { animation: `${animName} 0.6s ease-in-out infinite`, transformOrigin: 'bottom center' }
                : {}),
        }}
    />
);

export const LeftHand = (props: HandProps) => <HandBase side="left" {...props} />;
export const RightHand = (props: HandProps) => <HandBase side="right" {...props} />;
